import React from 'react';

const NotFound = () => {
    return (
        <div className='bg-red-200 my-20 p-20 font-semibold text-lg mx-20 rounded-xl'>
            <h2>The page is not Available!!!</h2>
            <p className='text-orange-400 p-1'>404</p>
        </div>
    );
};

export default NotFound;